var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConnecting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C11.4477 4 11 4.44772 11 5V8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8L13 5C13 4.44772 12.5523 4 12 4Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15C11.4477 15 11 15.4477 11 16V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19L13 16C13 15.4477 12.5523 15 12 15Z",
    fill: "#333333",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 11.4477 8.55228 11 8 11H5C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13L8 13C8.55228 13 9 12.5523 9 12Z",
    fill: "#333333",
    fillOpacity: 0.75
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 12C20 11.4477 19.5523 11 19 11H16C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13L19 13C19.5523 13 20 12.5523 20 12Z",
    fill: "#333333",
    fillOpacity: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7929 6.20305C17.4024 5.81253 16.7692 5.81253 16.3787 6.20305L14.2574 8.32437C13.8668 8.71489 13.8668 9.34806 14.2574 9.73858C14.6479 10.1291 15.281 10.1291 15.6716 9.73858L17.7929 7.61726C18.1834 7.22674 18.1834 6.59357 17.7929 6.20305Z",
    fill: "#333333",
    fillOpacity: 0.125
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7929 17.7471C17.4024 18.1377 16.7692 18.1377 16.3787 17.7471L14.2574 15.6258C13.8668 15.2353 13.8668 14.6021 14.2574 14.2116C14.6479 13.8211 15.281 13.8211 15.6716 14.2116L17.7929 16.3329C18.1834 16.7235 18.1834 17.3566 17.7929 17.7471Z",
    fill: "#333333",
    fillOpacity: 0.375
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79289 9.74715C9.40237 10.1377 8.7692 10.1377 8.37868 9.74715L6.25736 7.62583C5.86684 7.2353 5.86684 6.60214 6.25736 6.21161C6.64788 5.82109 7.28105 5.82109 7.67157 6.21161L9.79289 8.33293C10.1834 8.72346 10.1834 9.35662 9.79289 9.74715Z",
    fill: "#333333",
    fillOpacity: 0.875
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.79289 14.203C9.40237 13.8125 8.7692 13.8125 8.37868 14.203L6.25736 16.3244C5.86684 16.7149 5.86684 17.3481 6.25736 17.7386C6.64788 18.1291 7.28105 18.1291 7.67157 17.7386L9.79289 15.6173C10.1834 15.2267 10.1834 14.5936 9.79289 14.203Z",
    fill: "#333333",
    fillOpacity: 0.625
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecting);
export default __webpack_public_path__ + "static/media/connecting.b4c9760057a761b7372ca599ed21ea4a.svg";
export { ForwardRef as ReactComponent };